import Vuex from 'vuex'
import Vue from 'vue'
import user from './modules/user'
import auth from './modules/auth'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
      user,
      auth,
    },
    strict: debug,
    state: {
        contentloaded: false,
        country: localStorage.getItem('country'),
        cart: JSON.parse(localStorage.getItem('cart')) || [],
        stock: 1111,
        charge: {},
        userinfo: 1111
    },
    mutations:{
        setContentLoaded: (state, payload) => {
            state.contentloaded = payload;
        },
        setCountry: (state, payload) => {
            state.country = payload;
        },
        refreshUser: (state, payload) => {
            state.userinfo = payload;
        },
        updateStock: (state, payload) => {
            state.stock = payload;
        },
        setCart: (state, payload) => {
            state.cart.push(payload);
        },
        setQuantity:(state, payload) => {
            let item = state.cart.find(product => {
                return product.id === payload.id
            });
            item.qty = payload.qty;
        },
        setPrice: (state, payload) => {
            let item = state.cart.find(product => {
                return product.id === payload.id
            });
            item.subtotal = payload.subtotal;
        },
        setCharge: (state, payload) => {
            state.charge = payload;
        }
    },
    getters: {
        getContentLoaded: state => state.contentloaded,
        getCountry: state => state.country,
        getCart: state => state.cart,
        getCharge: state => state.charge,
        getUsername: state => state.userinfo
        // getTempMessage: state => state.stock
    },
    

});



// WEBPACK FOOTER //
// ./src/store/index.js